module.exports = __webpack_public_path__ + "static/media/work2.03663d52.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/work2.png
// module id = 45
// module chunks = 0